import React from 'react';
import ReactDOM from 'react-dom';
import { FormBuilder } from 'shared-components/forms/form';
import { TokenField } from '../elements-inputs/token-field';
import { NotificationBanner } from '../elements-banner/notification-banner';
import Projects from '../../../api/api-projects';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import urlRegex from 'url-regex-safe';

class ProjectShareForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      errorMsg: ''
    };

    this.postInvite = this.postInvite.bind(this);
    this.postInviteCb = this.postInviteCb.bind(this);
    this.analyticsPayload = this.analyticsPayload.bind(this);
    this.messageValue = this.props.intl.formatMessage({ id: 'boards.project_share_form.check_spaces', defaultMessage: 'Check out the spaces I found on Peerspace! Comment on the ones you like.' });
  }

  componentDidMount () {
    const { analyticsOrigin, project, activity, inviteOrigin } = this.analyticsPayload();

    analyticsIntegrations.shareBoardViewed(project, analyticsOrigin, activity, inviteOrigin);
  }

  postInvite (el, callback, refs, formValues) {
    const { sharedProject } = this.props;
    const metaEmail = formValues.meta_email;
    if (metaEmail) { return false; }

    const { invite_emails, personal_message } = formValues;
    const payload = {
      emails: invite_emails,
      message: personal_message
    };

    const accessToken = PSSessions.Cookies('PSAccess');
    Projects.createInvites(accessToken, sharedProject._id, payload, callback);
  }

  postInviteCb (res) {
    const { analyticsOrigin, project, activity, inviteOrigin} = this.analyticsPayload();
    if (res.error || res.errors || 400 <= res.statusCode) {
      let errorMsg = this.props.intl.formatMessage({ id: 'boards.project_share_form.something_went_wrong', defaultMessage: 'Something went wrong. Please try again later.' });
      if (res.error && res.display) {
        errorMsg = res.error;
      }
      // Something went wrong when creating the project
      return this.setState({ errorMsg });
    }
    const inviteCount = res.invites.length;
    const isDefaultMsg = res.message === this.messageValue;
    analyticsIntegrations.shareInviteSent(project, analyticsOrigin, activity, inviteCount, isDefaultMsg, inviteOrigin);

    const bannerMessage = () => {
      return (
        <ul className="text-center list-inline">
          <li>
            <i className="ico icon-yes"></i>
          </li>
          <li>
            <FormattedMessage
              id="boards.project_share_form.invite_sent"
              defaultMessage="Your invite was sent"
            />
          </li>
        </ul>
      );
    };

    this.props.closeModal();
    return ReactDOM.render(
      <SharedIntlProviderHOC>
        <NotificationBanner
          timing={4.6}
          message={bannerMessage()}
        />
      </SharedIntlProviderHOC>, document.getElementById('banner-container')
    );
  }

  buttonText () {
    return (
      <div>
        <i className="ico ico-md icon-mail-outline margin-lg-right"></i>
        <FormattedMessage
          id="boards.project_share_form.send_invite"
          defaultMessage="Send Invite"
        />
      </div>
    );
  }

  personalMessageConstraints (value) {
    const containsUrls = urlRegex().test(value);
    if (containsUrls) {
      return this.props.intl.formatMessage({
        id: 'boards.project_share_form.remove_urls',
        defaultMessage: 'Please remove urls from the message.'
      });
    }
  }

  analyticsPayload () {
    const { sharedProject, analyticsOrigin, emailOrigin } = this.props;
    const activity = PSSessions.Cookies('PSSK');
    const projectOmitArray = ['canonical_loc_data', 'created_by_profile', 'seo_index', 'statusCode', 'type'];
    const trimmedProject = _.assign({}, _.omit(sharedProject, projectOmitArray));
    const inviteOrigin = emailOrigin || analyticsOrigin;
    return {
      project: trimmedProject,
      analyticsOrigin,
      activity,
      inviteOrigin
    };
  }

  renderTokenField () {
    return (
      <div className='text-left form-group has-feedback'>
        <label className="control-label vert-align-label">
          <FormattedMessage
            id="boards.project_share_form.invite_email"
            defaultMessage="Invite By Email"
          />
        </label>
        <div>
          <TokenField
            ref="inviteEmail"
            inputFieldName="invite_emails"
          />
        </div>
      </div>
    );
  }

  render () {
    const formInputs = [
      {
        custom: this.renderTokenField
      },
      {
        inputFieldName: 'personal_message',
        elementID: 'personal-message',
        colSize: 'relative',
        ref: 'personalMessage',
        defaultVal: this.messageValue,
        actionFn: null,
        actionCb: null,
        optional: false,
        customConstraints: this.personalMessageConstraints
      },
      {
        inputFieldName: 'meta_email',
        ref: 'metaEmail',
        actionFn: null,
        actionCb: null,
        colSize: 'meta-email',
        optional: true
      }
    ];

    return (
      <div className='padding-xl-left padding-xl-right padding-xl-bottom'>
        <FormBuilder
          ref='msgHostForm'
          formname='msg host form'
          formStyle='modal'
          formInputs={formInputs}
          submitAction={this.postInvite}
          submitCallback={this.postInviteCb}
          buttonText={this.buttonText()}
          buttonClass='btn btn-ui-purple full-width margin-lg-top'
          errorText={this.props.errorText || this.state.errorMsg}
          useBootstrapGrid={false}
        />
      </div>
    );
  }
}

exports.ProjectShareForm = injectIntl(ProjectShareForm, { withRef: true });
